<template>
  <van-popup
    v-model="visible"
    position="bottom"
    :style="{ height: '90vh' }"
    closeable
  >
    <div class="dialog-container">
      <div class="dialog-title">新增物料</div>

      <van-form ref="form" @submit="onSubmit" class="form-wrapper">
        <!-- 产品标题 -->
        <van-field
          v-model="formData.productTitle"
          name="productTitle"
          label="产品标题"
          placeholder="请输入产品标题"
          :rules="[{ required: true, message: '产品标题不能为空' }]"
        />

        <!-- 物料唯一ID -->
        <van-field
          v-model="formData.materielUniqueId"
          name="materielUniqueId"
          label="物料ID(可自动生成)"
          placeholder="可自动生成，也可手动输入"
          @focus="generateMaterielId"
        />

        <!-- 产品信息 -->
        <van-field
          v-model="formData.productInfo"
          name="productInfo"
          label="产品信息"
          type="textarea"
          placeholder="请输入产品信息"
          rows="3"
          :rules="[{ required: true, message: '产品信息不能为空' }]"
        />

        <!-- 采购人 -->
        <van-field
          v-model="formData.purchaser"
          name="purchaser"
          label="采购人"
          placeholder="请输入采购人名称"
          :rules="[{ required: true, message: '采购人不能为空' }]"
        />

        <!-- 供货商 -->
        <van-field
          v-model="formData.supplier"
          name="supplier"
          label="供货商"
          placeholder="请输入供货商名称"
          :rules="[{ required: true, message: '供货商不能为空' }]"
        />

        <!-- 联系电话 -->
        <van-field
          v-model="formData.contactPhone"
          name="contactPhone"
          label="联系电话"
          type="tel"
          placeholder="请输入联系电话"
          :rules="[
            { required: true, message: '联系电话不能为空' },
            { pattern: /^[\d-+\s()]*$/, message: '电话号码格式不正确' }
          ]"
        />

        <!-- 购买链接 -->
        <van-field
          v-model="formData.purchaseLink"
          name="purchaseLink"
          label="购买链接"
          placeholder="请输入购买链接（可选）"
          type="url"
        />

        <!-- 购买价格（额外字段，方便展示） -->
        <van-field
          v-model.number="formData.purchasePrice"
          name="purchasePrice"
          label="参考价格"
          type="number"
          placeholder="请输入参考价格（可选）"
        />

        <!-- 产品图片 -->
        <div class="image-upload-wrapper">
          <div class="field-label">产品图片</div>
          <van-uploader
            v-model="fileList"
            :after-read="handleImageUpload"
            accept="image/*"
            multiple
            max-count="3"
          />
        </div>

        <!-- 提交按钮 -->
        <div class="form-footer">
          <van-button
            block
            type="primary"
            native-type="submit"
            :loading="loading"
          >
            保存
          </van-button>
          <van-button
            block
            @click="visible = false"
            style="margin-top: 10px"
          >
            取消
          </van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      fileList: [],
      formData: {
        productTitle: '',
        materielUniqueId: '',
        productInfo: '',
        purchaser: '',
        supplier: '',
        contactPhone: '',
        purchaseLink: '',
        purchasePrice: null,
        productImage: '',
      },
    };
  },

  methods: {
    open() {
      this.visible = true;
      this.resetForm();
    },

    resetForm() {
      this.formData = {
        productTitle: '',
        materielUniqueId: '',
        productInfo: '',
        purchaser: '',
        supplier: '',
        contactPhone: '',
        purchaseLink: '',
        purchasePrice: null,
        productImage: '',
      };
      this.fileList = [];
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },

    generateMaterielId() {
      // 自动生成物料ID（时间戳 + 随机数）
      if (!this.formData.materielUniqueId) {
        const timestamp = Date.now();
        const random = Math.floor(Math.random() * 1000);
        this.formData.materielUniqueId = `MAT${timestamp}${random}`;
      }
    },

    handleImageUpload(file) {
      // 处理图片上传，如果是base64或file对象，可以直接设置或上传
      if (file.content) {
        // 如果是经过处理的文件对象
        this.formData.productImage = file.content;
      } else if (file.file) {
        // 如果需要上传到服务器
        this.uploadImageToServer(file.file);
      }
      this.$toast('图片已添加');
    },

    uploadImageToServer(file) {
      const formData = new FormData();
      formData.append('file', file);

      this.axios
        .post('/Materiel/UploadImage', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.data.code === 101) {
            this.formData.productImage = response.data.data;
          }
        })
        .catch(() => {
          this.$toast.fail('图片上传失败');
        });
    },

    onSubmit() {
      this.$refs.form.validate().then(() => {
        this.loading = true;

        this.axios
          .post('/Materiel/Add', this.formData)
          .then((response) => {
            this.loading = false;
            if (response.data.code === 101) {
              this.$toast.success('添加成功');
              this.visible = false;
              this.$emit('success');
            } else {
              this.$toast.fail(response.data.msg || '添加失败');
            }
          })
          .catch(() => {
            this.loading = false;
            this.$toast.fail('添加失败');
          });
      });
    },
  },
};
</script>

<style scoped>
.dialog-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.dialog-title {
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #f0f0f0;
}

.form-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;
}

.image-upload-wrapper {
  padding: 16px 0;
  border-bottom: 1px solid #ebedf0;
}

.field-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-footer {
  padding: 16px;
  border-top: 1px solid #f0f0f0;
  background: #fff;
}
</style>
